import { apolloClient } from "@td/ui"
import UPDATE_PRACTICE_TEAM from "../mutations/update_practice_team.graphql";

const updatePracticeTeam = async (variables) => {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_PRACTICE_TEAM,
    variables,
  });

  return data.tasUpdatePracticeTeam;
}

export default updatePracticeTeam;
